import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { takeUntil } from 'rxjs/operators';
import { PopoverService } from 'app/core/services/popover.service';

@Component({
  selector: 'app-integration-monkey-page',
  templateUrl: './integration-monkey-page.component.html',
  styleUrls: ['./integration-monkey-page.component.scss']
})
export class IntegrationMonkeyPageComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('integrationMonkey', { static: true }) pageRef: ElementRef;

  @HostListener('document:click', ['$event'])
  onHidePopover(event: MouseEvent) {
    if (window && window.getSelection && window.getSelection().toString().length) {
      return;
    }
    const { list } = this.popoverService;
    for(let key in list) {
      const popover = list[key];
      popover.hide();
    }
  }
  
  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService,
    private popoverService: PopoverService,
  ) {}

  ngOnInit(): void {
    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(() => {
      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    const userStyles = window['documentManager'].createElement('link');
    userStyles.href = 'paybee-spa/styles.css?v=398';
    userStyles.rel = 'stylesheet';
    window['$'](this.pageRef.nativeElement).append(userStyles);
  }

  ngOnDestroy(): void {
    const $ = window['$'];
    $("#integrationMonkey").hide();
    $("#integrationMonkey").empty();

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
